module.exports = {"errors_404":{"title":["Page <span>introuvable !</span>","Page <span>not found!</span>"],"description":["La page demandée n'est malheureusement pas disponible.","The requested page was not found. The link is broken or the page has been moved."]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Errors/translations/translations_errors.json
// module id = 1122
// module chunks = 0